module.exports = __webpack_public_path__ + "img/Group 175.e752a95b.svg";